// extracted by mini-css-extract-plugin
module.exports = {"main-component":"messageIcon_main-component__JRDhG"};